module.exports = __webpack_public_path__ + "img/paypal-1.80d588ce.svg";